import {flow, getEnv, getType, resolveIdentifier, types} from 'mobx-state-tree';
import MediaFileStore from "../../../stores/domain/MediaFileStore";
import {MediaFile} from "../../../models/mediaFiles/MediaFileModel";

export const MediaFileSelectState = types.model('MediaFileSelectState',{
  selectStateUuid: types.identifier,
  store: types.maybe(types.late(() => types.reference(MediaFileStore))),
  selected: types.maybeNull(types.safeReference(MediaFile)),
  name: types.optional(types.string, "MediaFile"),
  isMediaFileEnabled: types.optional(types.boolean, false),
}).volatile((self)=>({
  notifySelect: types.str,
})).actions((self) => ({
  search(txt){
    //self.groupOptions = self.groupStore.searchFor(txt)
    //self.groupStore.groups
  },
  setConsumer(f){
    self.notifySelect = f
  },
  select: flow(function* f(file,experienceFieldName, notify) {

    if(file && file?.uuid) {
      self.selected = resolveIdentifier(MediaFile, self.store, file.uuid)
      self.notifySelect(resolveIdentifier(MediaFile, self.store, file.uuid),experienceFieldName)

        //call on manager to get s3URL
    }else{
      self.selected = undefined
      // self.notifySelect(null)
    }
  }),
  setSelectedToUndefined(){
    self.selected = undefined
    self.notifySelect(undefined)
  },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => { //TODO
      console.log("placeholder notifySelect")
    }
    self.selectedSchema = {}
  },
  updateSingleUseFile: flow(function* updateSingleUseFile(file) {
    yield self.store.getMediaFiles({"usage":"content","status":"UPLOADED"}); // this will remove any single use file from the list
    const updatedFile = yield self.store.getMediaFile(file.uuid);
    self.store.addFileToList(updatedFile.fileLocation)
    return true
  }),
  handleAddAndSelectNewMediaFile: flow(function* handleAddAndSelectNewMediaFile(uuid,experienceFieldName) {
    yield self.select({uuid:uuid},experienceFieldName);

  }),
})).views( (self) => ({
  shouldRenderSelect() {

    return self.store && self.store.flatList && self.store.flatList.length > 0
  },
  options() {
    const list = self.store?.list || [];
    return list || [];
  },
}))


